// src/components/Dashboard.jsx
import { useElectronData } from '../hooks/useElectronData'
import { useDataStore } from '../stores/dataStore'
import TitleBar from './TitleBar'
import MetricsBar from './MetricsBar'
import PacketsWidget from './PacketsWidget'
import TabBar from './TabBar'
import ConnectionsList from './ConnectionsList'
import AppsList from './AppsList'
import AlertsPanel from './AlertsPanel'
import Onboarding, { useOnboarding } from './Onboarding'

export default function Dashboard() {
  const { dismissAlert } = useElectronData()
  const activeTab = useDataStore(s => s.activeTab)
  const [showOnboarding, doneOnboarding] = useOnboarding()

  return (
    <div className="grain" style={{
      display: 'flex', flexDirection: 'column',
      height: '100vh', background: 'var(--bg-base)', overflow: 'hidden',
    }}>
      <TitleBar />
      <PacketsWidget />
      <MetricsBar />
      <TabBar />
      <div style={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
        {activeTab === 'connections' && <ConnectionsList />}
        {activeTab === 'apps'        && <AppsList />}
        {activeTab === 'alerts'      && <AlertsPanel onDismiss={dismissAlert} />}
      </div>
      {showOnboarding && <Onboarding onDone={doneOnboarding} />}
    </div>
  )
}
